import {GamificationLevelService} from 'src/app/services/profile/gamification-level.service';
import {TranslationConfig} from 'src/app/utils/translate-config';
import {GameStateService} from './services/profile/game-state.service';
import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  LOCALE_ID,
  PLATFORM_ID,
  Renderer2,
  ViewChild,
  effect,
  inject
} from '@angular/core';
import {MatSidenav} from '@angular/material/sidenav';
import {BasePageComponentWithDialogs} from './components/base-page/base-page.component';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterEvent} from '@angular/router';
import {handleMessages} from './utils/bo-messages.handler';
import {delay, distinctUntilChanged, filter, switchMap, take, takeUntil} from 'rxjs/operators';
import {topMenuAction} from './components/top-menu/top-menu-button/top-menu-button.component';
import {LoginStatusService} from './services/auth/login/login-status.service';
import {LoggedStatus} from './services/auth/login/login.models';
import {PreloadService} from './services/utils/preload-on-start.service';
import {DOCUMENT, isPlatformBrowser, isPlatformServer} from '@angular/common';
import {DetectDeviceService} from './services/utils/detect-device.service';
import {MinimizeSiteService} from './services/utils/hide-footer.service';
import {OpenDesktopDrawerService} from './services/utils/open-desktop-drawer.service';
import {CookieService} from 'ngx-cookie-service';
import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';
import {NotificationService} from './services/notofications/notification.service';
import {InitialDataService} from './services/page/initial-data.service';
import {crossSellTrx, desktopTrx, gameTrx, launchGameTrx, liveCasinoTrx, loginTrx, signUpTrx, sportsBookTrx} from './router-translation.labels';
import {LicenceService} from './services/utils/licence.service';
import {NavigationService} from './services/navigation/navigation.service';
import {environment} from 'src/environments/environment';
import {COUNTRY_ID, LICENCE} from './global.tokens';
import {UserCampaignService} from './services/campaigns/campaign.service';
import {UserInfoService} from './services/auth/check-session/user-info.service';
import {
  DynamicNotificationComponent
} from './components/notifications/dynamic-notification/dynamic-notification.component';
import {BonusQueueService} from './services/wallet/bonus-queue.service';
import {DepositService} from './services/payment/deposit/deposit.service';
import {hashCode} from './utils/general-utils';
import {InstallPromptService} from './services/pwa/install-prompt.service';
import {WINDOW} from '@ng-web-apis/common';
import {PushTokenService} from './services/http/push-token.service';
import {MissionService} from './services/missions/mission.service';
import {TournamentService} from './services/tournaments/tournament.service';
import {getMappedCategoryLink, routerMapping} from './router-mapping';
import {LoaderService} from './services/utils/loader/loader.service';
import {GameCategory} from './apollo/models/base-models';
import { DomainRedirectDialogComponent } from './components/domain-redirect-dialog/domain-redirect-dialog.component';
import { ResponsibleGamingDialogComponent } from './components/dialog/responsible-gaming-dialog/responsible-gaming-dialog.component';
import { CustomNotificationService } from './services/profile/custom-notification.service';
import { CrossSellContentData, CrossSellUserDataService } from './services/profile/cross-sell-data.service';
import { combineLatest, of } from 'rxjs';
import { CrossSellBonusDialogComponent } from './components/cross-sell-bonus-dialog/cross-sell-bonus-dialog.component';

declare let gtag: Function;
declare let fbq: Function;

const META_PIXEL_DOMAINS = ['lemoncasinono.com', 'lemoncasino.io'];
const isMetaPixelDomain = () => typeof window !== 'undefined' && META_PIXEL_DOMAINS.includes(window.location.hostname);
const errorMessage: string = $localize`:@@errorGoogleLogin:Something went wrong.`;
const userExistAfterGoogleLogin: string = $localize`:@@userExistAfterGoogleLogin:User already exist`;
const emailNotConfirmed: string = $localize`:@@confirmEmail:Your email is not confirmed, please log in manually.`;
const blockedHeader: string = $localize`:@@blockedHeader:Your account is unavailable`;
const locationBlockedBody: string = $localize`:@@locationBlock:Login blocked: your current location or IP is not supported.
If you are in an allowed country and believe this is an error, please contact Support.
Otherwise, your account will stay unavailable from here`;
const accountBlockedBody: string = $localize`:@@accountBlock:For your safety and in line with our policies, your account is blocked.
This may be due to security reasons or responsible gaming settings.
You cannot log in or play.`;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends BasePageComponentWithDialogs {
  title = 'casino-first';
  @ViewChild('sidenav') sidenav: MatSidenav;
  @ViewChild('mainbackground') mainBackground: ElementRef;

  TOP_MENU_IDENTIFIER: string = 'top_menu';
  private swMessageHandler: (evt: any) => void;

  loginDialogLink: string;
  isOpened: boolean = false;
  minimizePage: boolean = false;
  isMaintenance: boolean = false;

  isPromotion: boolean = false;
  showInstall: boolean = false;
  installEvent: any;

  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  isRegularPage: boolean;
  isFooterShow: boolean;
  isFullPage: boolean;
  showHeader: boolean;
  // isToolBar: boolean;
  // isFooter: boolean;
  displayGamificationProgress: boolean = false;
  level: number;
  crossSellTranslations: CrossSellContentData;

  constructor(
    public navigation: NavigationService,
    dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private loginStatus: LoginStatusService,
    private preloadService: PreloadService,
    public detectDeviceService: DetectDeviceService,
    public matDialog: MatDialog,
    public minimizeSiteService: MinimizeSiteService,
    public openDrawerService: OpenDesktopDrawerService,
    private notificationService: NotificationService,
    private intialDataService: InitialDataService,
    private snackBar: MatSnackBar,
    private cookiesService: CookieService,
    private userCampaignService: UserCampaignService,
    protected licenceService: LicenceService,
    protected translationConfig: TranslationConfig,
    private gameStateService: GameStateService,
    private gamificationLevelService: GamificationLevelService,
    private campaignService: UserCampaignService,
    private userInfoLoginService: UserInfoService,
    private depositService: DepositService,
    @Inject(PLATFORM_ID) private platformId,
    @Inject(LOCALE_ID) protected locale,
    @Inject(DOCUMENT) private _document: Document,
    @Inject(WINDOW) private WINDOW: Document,
    @Inject(LICENCE) private licence: String,
    private _renderer2: Renderer2,
    private bonusQueueService: BonusQueueService,
    private installPromptService: InstallPromptService,
    private pushTokenService: PushTokenService,
    private missionService: MissionService,
    private tournamentService: TournamentService,
    private loaderService: LoaderService,
    private customNotificationService: CustomNotificationService,
    private crossSellService: CrossSellUserDataService,
  ) {
    effect(() => {
      this.displayGamificationProgress = gamificationLevelService.animateGamificationProgress();
    });
    super(dialog, detectDeviceService);

    if (!this.detectDeviceService.isDesktop()) {
      this.showLoaderFromPath(WINDOW.location.pathname);
    }

    if (!isPlatformServer(this.platformId)) {
      WINDOW.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        this.installEvent = e;
        if (environment.enableServiceWorker)
          this.showInstallPopup();
        // console.log('fired beforeinstallprompt')
      })

      WINDOW.addEventListener('appinstalled', (e) => {
        // console.log('Installation completed')
      })
    }

  }

  ngOnInit(): void {
    if (isPlatformServer(this.platformId)) {
      this.missionService.prefetchMissionsSSR(this.platformId).then(
        // () => console.log('[AppComponent Missions] SSR missions prefetch complete')
      ).catch(
        (err) => console.error('[AppComponent Missions] SSR missions prefetch error', err)
      );
    }

    if (isPlatformServer(this.platformId)) {
      this.tournamentService.prefetchTournamentsSSR(this.platformId).then(
        // () => console.log('[AppComponent Tournament] SSR tournament prefetch complete')
      ).catch(
        (err) => console.error('[AppComponent Tournament] SSR tournament prefetch error', err)
      );
    }

    if (isPlatformServer(this.platformId)) {
      this.tournamentService.prefetchNetworkTournamentsSSR(this.platformId).then(
        // () => console.log('[AppComponent Tournament (network)] SSR tournament prefetch complete')
      ).catch(
        (err) => console.error('[AppComponent Tournament (network)] SSR tournament prefetch error', err)
      );
    }


    if (isPlatformBrowser(this.platformId)) {
      // this.notificationService.fetchuser().pipe(take(1)).subscribe((resp) => console.log(resp, 'userresp trigger fetch user'))
    }
    this.isRegularPage = true;
    this.isFooterShow = true;
    this.isFullPage = true;
    this.showHeader = true;
    if (isPlatformBrowser(this.platformId)) {
      const currentHostname = window.location.hostname.replace(/^www\./, '');
      if (currentHostname === 'lemoncasinohu27.com') {
        setTimeout(() => {
          this.matDialog.open(DomainRedirectDialogComponent, {
            width: '520px',
            maxWidth: '90vw',
            backdropClass: 'blur-backdrop',
            panelClass: ['transparent', 'auth-card-container'],
            disableClose: true,
          });
        }, 800);
      }
    }

    if (isPlatformBrowser(this.platformId)) {
      this.customNotificationService.watchNotifications().pipe(
        takeUntil(this.unsubscribe),
      ).subscribe();
    }

    if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
      this.swMessageHandler = (evt: any) => {
        if (evt.data?.type === 'NAVIGATE' && evt.data.url) {
          const path = evt.data.url;
          //console.log('[App] Navigate request from SW:', path);
          this.router.navigateByUrl(path);
        }
      };
      navigator.serviceWorker.addEventListener('message', this.swMessageHandler);
    }

    this.scheduleAfterLoadIdle(() => {
      this.gamificationLevelService.getGamification(true).pipe(
        filter(resp => !!resp),
        takeUntil(this.unsubscribe),
      ).subscribe((resp) => {
        this.level = Math.ceil(resp?.levelNumber / 5);
      });
    });
    if (!isPlatformServer(this.platformId)) {

      const siteId = 3925400;
      const hotjarVersion = 6;
      // if (this.licence === 'bison_india' || this.locale.toLowerCase() === 'no' || this.locale.toLowerCase() === 'en-ca') {
      //   Hotjar.init(siteId, hotjarVersion);
      // }
      /* DEV COMMENT - meta pixel fires are to be removed until further notice */
      /* this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.unsubscribe),
      ).subscribe(() => {
        if (typeof fbq !== 'undefined' && isMetaPixelDomain()) {
          fbq('track', 'PageView');
        }
      }); */

      this.router.events.pipe(
        filter((event) => event instanceof NavigationStart),
        //filter((event: RouterEvent) => event instanceof NavigationStart),
        takeUntil(this.unsubscribe),
      ).subscribe(event => {
          // if (this.detectDeviceService.isDesktop()) {
          //   if (!event.url.startsWith('/' + desktopTrx)) {
          //     this.router.navigateByUrl(`/${desktopTrx}${event.url.length > 1 ? event.url.replace('/?', '?') : ''}`)
          //   }
          // }
          // else {
          if ((event as RouterEvent).url.startsWith('/' + desktopTrx)) {
            this.router.navigateByUrl((event as RouterEvent).url.substring(desktopTrx.length + 1))
          }
          // }
        }
      )
    }

    this.userInfoLoginService.requestCheckUserInfo().pipe(takeUntil(this.unsubscribe)).subscribe((resp) => {
    });

    this.minimizeSiteService.isRegularPage().pipe(takeUntil(this.unsubscribe), distinctUntilChanged()).subscribe(resp => {
      this.isRegularPage = resp;
      this.isFooterShow = resp;
    });

    this.minimizeSiteService.isFooterNotMinimized().pipe(takeUntil(this.unsubscribe), distinctUntilChanged()).subscribe(resp => {
      this.isFooterShow = resp;
    });

    this.minimizeSiteService.isHeaderNotMinimized().pipe(takeUntil(this.unsubscribe), distinctUntilChanged()).subscribe(resp => {
      this.showHeader = resp;
    });

    this.minimizeSiteService.isAllNotMinimized().pipe(takeUntil(this.unsubscribe), distinctUntilChanged(), delay(10)).subscribe((res) => {
      this.isFullPage = res;
    });

    this.intialDataService.fetchData().pipe(take(1)).subscribe(resp => {
      this.isMaintenance = resp.maintenance.enabled;

      if (!isPlatformServer(this.platformId)) {
        this.injectPageScriptsAfterLoad(resp.pageScripts);
      }
    })
    if (!!this.licenceService.getKey("title-substitute")) {
      const title = this.licenceService.getKey("title-substitute");
      this.setSEOTags(title);
    } else if (!this.titleService.getTitle()) {
      this.setSEOTags();
    }
    // this.meta.removeTag('description');
    // this.meta.addTag({ name: 'description', content: $localize`:@@meta-front-page:Join Lemon Casino Best Online Casino. Online Slots or maybe Live Casino Games? You decide. A wide range of games and benefits for new players and many loyalty bonuses such as Cashback, Lemon Lottery, or Treasure Box!` })
    this.cookiesService.set('firebase-country-override', this.locale);
    // this.pageMappingService.createStaticPageMapping();

    if (isPlatformBrowser(this.platformId)) {
      if (!!window.location.hash && window.location.hash === '#action:user.email_confirmed') {
        handleMessages(this, this.matDialog, 'email_confirm', this.gameStateService, this.router, this.loginStatus, this.translationConfig, true);

        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    }

    this.route.queryParams.pipe(takeUntil(this.unsubscribe), take(3)).subscribe((params) => {
      if (typeof window !== 'undefined' && window.top !== window.self && params?.['action'] === 'payment') {
        return;
      }

      if (!!params && params['pass']) {
        if (params['pass'] === "googleLogin") {
          sessionStorage.setItem('enableGoogleLogin', 'true');
        }
      }

      if (!!params && params['action']) {
        if (params['action'] === 'error') {
          if (!params['message']) {
            this.openErrorDialog(errorMessage);
            return this.router.navigate(['/']);
          }

          this.openErrorDialog(params['message']);
          this.router.navigate(['/']);
        }

        if (params['action'] === 'login' && params['value'] === 'finish_registration') {
          const pathParts = this.router.url.split('/');
          const currentLang = pathParts.length > 1 && pathParts[1].match(/^([a-zA-Z]{2})(-[A-Z]{2})?$/gm) ? pathParts[1] : '';
          const translatedSignup = this.translationConfig.getTranslation(signUpTrx);
          const redirectPath = currentLang ? `/${currentLang}/${translatedSignup}` : `/${translatedSignup}`;

          this.router.navigate([redirectPath], {queryParamsHandling: 'preserve'});
        }

        if (params['action'] === 'login' && params['value'] === 'manual') {
          this.openSuccessDialog(
            emailNotConfirmed,
            userExistAfterGoogleLogin,
            () => {
              this.router.navigate(['/' + loginTrx])
            });
        }

        if (params['action'] === 'location_blocked') {
          this.openErrorDialog(locationBlockedBody, blockedHeader);
          this.router.navigate(['/']);
        }

        if (params['action'] === 'account_blocked') {
          this.openErrorDialog(accountBlockedBody, blockedHeader);
          this.router.navigate(['/']);
        }

        if (params['action'] !== 'login' && params['action'] !== 'error') {
          handleMessages(this, this.matDialog, params['value'], this.gameStateService, this.router, this.loginStatus, this.translationConfig);
          this.router.navigate([this.router.url.split('?')[0]])
        }
      }

      if (!!params && params['cst']) {
        const pathParts = this.router.url.split('/');
        const currentLang = pathParts.length > 1 && pathParts[1].match(/^([a-zA-Z]{2})(-[A-Z]{2})?$/gm) ? pathParts[1] : '';
        const translatedSignup = this.translationConfig.getTranslation(crossSellTrx);
        const redirectPath = currentLang ? `/${currentLang}/${translatedSignup}` : `/${translatedSignup}`;
        const parsedQuery = this.crossSellService.parseQueryParam(`cst=${params['cst']}`);
        this.crossSellService.setConfigName(parsedQuery.configName);

        this.crossSellService.getBackendData(parsedQuery.cst).pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
          this.crossSellService.setData(resp);

          this.router.navigate([redirectPath], {queryParamsHandling: 'preserve'});
        })
      }

      if (!!params && params['accr']) {
        let isDesktopDevice = this.detectDeviceService.isDesktop();
        combineLatest([
          this.crossSellService.getCrossSellTranslations(),
          this.crossSellService.getGamificationLevel()
        ]).pipe(
          take(1),
          switchMap(([translations, levelKey]) => {
            return combineLatest([
              of(translations),
              this.crossSellService.calculateCurrency(levelKey)
            ])
          })
        ).subscribe({
          next: ([translations, currencyData]) => {
            this.crossSellTranslations = translations;
            const { totalPrizeAmount, currencySymbol, isReadyAmount } = currencyData;
            this.crossSellService.fulfillUserAddress();

            this.matDialog.open(CrossSellBonusDialogComponent, {
              width: isDesktopDevice ? '613px' : '96vw',
              height: isDesktopDevice ? '630px' : '625px',
              maxWidth: !isDesktopDevice ? '96vh' : '',
              position: {
                top: isDesktopDevice ? '160px' : '64px'
              },
              panelClass: 'cross-sell-reward-dialog',
              data: { symbol: currencySymbol, amount: totalPrizeAmount, ready: isReadyAmount, isDesktop: isDesktopDevice, translations: this.crossSellTranslations }
            });
          },
          error: (err) => {
            console.error(err);
          }
        });
      }
    });

    this.openDrawerService.getStateInitial().pipe(takeUntil(this.unsubscribe)).subscribe()
    this.openDrawerService.getState().pipe(takeUntil(this.unsubscribe)).subscribe()
  }

  refreshBonusList(): void {
    this.bonusQueueService.getBonusList(true)
      .pipe(take(1), takeUntil(this.unsubscribe))
      .subscribe();
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)){
      this.callpwa();
    }
    if (!!this.sidenav) {
      this.sidenav.openedStart.pipe(takeUntil(this.unsubscribe)).subscribe(() =>
        this.isOpened = true
      )
      this.sidenav.closedStart.pipe(takeUntil(this.unsubscribe)).subscribe(() =>
        this.isOpened = false
      )
    }
    if (!isPlatformServer(this.platformId)) {
      this.loginStatus.getIfUserLogged().pipe(take(1)).subscribe((userInfo) => {
        this.depositService.getDepositDetail(userInfo).pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
          for (const deposit of resp) {
            // console.log('deposit', deposit)
            const isHasDeposit = userInfo.fullInfo.has_deposit;
            gtag('event', isHasDeposit ? 'subsequent_deposit' : 'first_deposit', {
              'user_id': userInfo.username, // user ID value is used for cross device tracking
              'email_hashed': hashCode(userInfo.username), // sha256 hash
              'email': userInfo.username,
              'value': deposit.deposit_value,
              'currency': userInfo.currency,
            })
          }
        });
      })
    }

    this.loginStatus.getIfUserLogged().pipe(take(1)).subscribe({
      next: () => this.refreshBonusList(),
      error: (err) => console.error('Error fetching login status:', err)
    });

    this.loginStatus.getLoginStatus().pipe(
      filter(status => status.isLogged === LoggedStatus.logged),
      takeUntil(this.unsubscribe),
    ).subscribe((userInfo) => {
      if (userInfo?.fullInfo?.responsible_gaming_reminder_popup) {
        this.openResponsibleGamingDialog();
      }
      // if (this.licence === 'bison_india' || this.locale.toLowerCase() === 'no' || this.locale.toLowerCase() === 'en-ca') {
      //   this.preloadService.updateStore(resp.username);
      //   Hotjar.identify(resp.username, {
      //     email: resp.username,
      //   });
      // }

      if (!isPlatformServer(this.platformId)) {


        this.notificationService.fetchNotifications().pipe(filter(resp => !!resp), takeUntil(this.unsubscribe)).subscribe((resp) => {
          const notificationNames: string[] = ["new-level", "chargeback-resolved", "tournament-prize", "first-deposit-boost-bonus", "campaign-update", "campaign-update-xmas", "vip-status", "tier-change"];
          const vipNotificationNames: string[] = ["vip-status-bronze", "vip-status-silver", "vip-status-gold"]
          const notificationsName: string = notificationNames.includes(resp.notifications[0]?.name.toLowerCase()) ? resp.notifications[0]?.name.toLowerCase() : "default-notification";
          const vipNotificationName: string | null = vipNotificationNames.includes(resp.notifications[0]?.name.toLowerCase()) ? resp.notifications[0]?.name.toLowerCase() : null;
          if (vipNotificationName) {
            this.openVipUpgradeDialog(this.licenceService.getKey(vipNotificationName), vipNotificationName)
          } else {
            !!resp.notifications[0] && this.snackBar.openFromComponent(DynamicNotificationComponent, {
              data: {
                text: resp.notifications[0].text,
                name: notificationsName,
                level: this.level
              },
              horizontalPosition: this.horizontalPosition,
              verticalPosition: this.verticalPosition,
              panelClass: ['my-snackbar', notificationsName],
              duration: 10000
            });
            this.notificationService.setNotificationSeen();
          }


        });


        this.userCampaignService.getActiveCampaign().pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
        });
      }

      // this.campaignService.getActiveCampaign().pipe(take(1)).subscribe(resp => {
      //   console.log(resp)
      // })

    });

    if (!isPlatformServer(this.platformId)) this.preloadImages();

    this.scheduleAfterLoadIdle(() => {
      this.pushTokenService.ensureTokenForUser().pipe(takeUntil(this.unsubscribe)).subscribe(token => {
        if (token) {
          // console.log('[App] Push token ready:', token);
        } else {
          // console.log('[App] Push token not available');
        }
      });
    });
  }

  private injectPageScriptsAfterLoad(pageScripts: { name: string; script: string }[]): void {
    if (!pageScripts?.length || isPlatformServer(this.platformId)) {
      return;
    }

    this.scheduleAfterLoadIdle(() => {
      pageScripts.forEach(script => {
        if (!!script.script) {
          const scriptElement = this._renderer2.createElement('script');
          scriptElement.type = 'text/javascript';
          scriptElement.src = script.script;
          this._renderer2.appendChild(this._document.body, scriptElement);
        }
      });
    }, 2000);
  }

  private scheduleAfterLoadIdle(cb: () => void, graceMs: number = 0): void {
    if (isPlatformServer(this.platformId)) {
      return;
    }

    const win = this.WINDOW as unknown as Window;

    const runIdle = () => {
      const idle = (win as any).requestIdleCallback as
        | ((c: () => void, opts?: { timeout: number }) => void)
        | undefined;
      if (typeof idle === 'function') {
        idle(cb, { timeout: 3000 });
      } else {
        win.setTimeout(cb, 0);
      }
    };

    const afterLoad = () => (graceMs > 0 ? win.setTimeout(runIdle, graceMs) : runIdle());

    if (this._document.readyState === 'complete') {
      afterLoad();
    } else {
      win.addEventListener('load', afterLoad, { once: true });
    }
  }

  ngOnDestroy(): void {
    if (this.swMessageHandler && typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
      navigator.serviceWorker.removeEventListener('message', this.swMessageHandler);
    }
    super.ngOnDestroy();
  }

  async callpwa() {
    // event may have fired before bootstrap, captured in main.ts
    if ((this.WINDOW as any).__deferredInstallPrompt) {
      this.installPromptService.deferredPrompt = (this.WINDOW as any).__deferredInstallPrompt;
    }
    try {
      await this.WINDOW.addEventListener('beforeinstallprompt', (e: any) => {
        e.preventDefault();
        this.installPromptService.deferredPrompt = e;
      });
      // app installed, drop the prompt so the app menu hides without reload
      this.WINDOW.addEventListener('appinstalled', () => {
        (this.WINDOW as any).__deferredInstallPrompt = null;
        this.installPromptService.deferredPrompt = null;
      });
    } catch (error) {
    }
  }

  showInstallPromotion() {
    this.isPromotion = true;
  }

  hideInstallPromotion() {
    this.isPromotion = false;
  }

  showInstallPopup() {
    this.showInstall = true;
    this.hideInstallPromotion();
  }

  hideInstallPopup() {
    this.showInstall = false;
  }

  private preloadImages() {
    // this.preloadImagesService.fetchData().pipe(takeUntil(this.unsubscribe)).subscribe((url) => {
    //   if (!!url) {
    //     let img = new Image();
    //     img.src = url;
    //   }

    // })
  }

  topClicked(value: topMenuAction) {
    if (value === topMenuAction.TOP) {
      this.sidenav.open();
    } else if (value === topMenuAction.BACK) {
      try {
        const returnToGameUrl = sessionStorage.getItem('returnToGameUrl');
        if (returnToGameUrl) {
          sessionStorage.removeItem('returnToGameUrl');
          this.router.navigateByUrl(returnToGameUrl, { state: { skipHistory: true } });
          return;
        }
      } catch {}

      const previousUrl = this.navigation.subjectPrevUrl.value;
      const blockedUrls = [
        signUpTrx,
        loginTrx,
        sportsBookTrx,
        launchGameTrx,
        "_refresh",
      ].map(trx => this.translationConfig.getTranslation(trx));

      const returnUrl = blockedUrls.some(url => previousUrl.includes(url)) ? '/' : previousUrl;
      this.router.navigateByUrl(returnUrl);
    }
  }

  close() {
    this.sidenav?.close();
  }

  onLogoClick(event?: Event) {
    try {
      sessionStorage.clear();
    } catch {}
  }

  private normalizePath(pathname: string): string {
    const baseEl = this._document.getElementsByTagName('base')?.[0];
    const baseHref = baseEl?.getAttribute('href') || '/';

    let p = pathname.startsWith(baseHref) ? pathname.slice(baseHref.length - 1) : pathname;
    p = p.replace(/^\/+/, '');
    p = p.replace(/#[\s\S]*$/, '');
    p = p.replace(/\?[\s\S]*$/, '');
    p = p.replace(/^[a-z]{2}(?:-[A-Z]{2})?\//, '');
    return p;
  }

  private allowedFirstSegs: Set<string> | null = null;

  private buildAllowedFirstSegs(): Set<string> {
    if (this.allowedFirstSegs) {
      return this.allowedFirstSegs;
    }

    const set = new Set<string>();
    const addSeg = (s?: string, reason?: string) => {
      if (!s) return;
      const seg = s.replace(/^\/+/, '').split('/')[0] || '';
      if (!seg) return;
      if (!set.has(seg)) {
        set.add(seg);
      }
    };

    routerMapping.forEach((cat, trx) => {
      addSeg(trx, 'raw trx');
      addSeg(cat, 'raw cat');

      const trxT = this.translationConfig.getTranslation(trx);
      const catT = this.translationConfig.getTranslation(cat);
      addSeg(trxT, 'translated trx');
      addSeg(catT, 'translated cat');

      const fakeCategory = {name: trx} as unknown as GameCategory;
      const mappedLink = getMappedCategoryLink(fakeCategory, this.translationConfig, /*useSlotsInPath*/ true);
      addSeg(mappedLink, 'mappedLink(first seg)');
    });

    addSeg(gameTrx, 'raw gameTrx');
    addSeg(this.translationConfig.getTranslation(gameTrx), 'translated gameTrx');
    addSeg(liveCasinoTrx, 'raw liveCasinoTrx');
    addSeg(this.translationConfig.getTranslation(liveCasinoTrx), 'translated liveCasinoTrx');

    this.allowedFirstSegs = set;

    return set;
  }

  private showLoaderByPath(pathname: string): boolean {
    const normalized = this.normalizePath(pathname);
    const firstSeg = normalized.split('/')[0] || '';
    const allowed = this.buildAllowedFirstSegs();

    const result = allowed.has(firstSeg);

    return result;
  }

  private showLoaderFromPath(pathname: string): void {
    const show = this.showLoaderByPath(pathname);
    if (show) {
      this.loaderService.show();
    } else {
      this.loaderService.hide();
    }
  }

  private openResponsibleGamingDialog(): void {
    const isDesktop = this.detectDeviceService.isDesktop();
    const alreadyOpen = this.matDialog.openDialogs.some(
      d => d.componentInstance instanceof ResponsibleGamingDialogComponent
    );
    if (alreadyOpen) { return; }
  
    this.matDialog.open(ResponsibleGamingDialogComponent, {
      width: 'calc(100% - 20px)',
      maxWidth: isDesktop ? '620px' : '394px',
      maxHeight: '90vh',
      backdropClass: "blur-backdrop",
      disableClose: true,
      panelClass: ["RG-dialog-container", isDesktop ? 'desktop' : 'mobile']
    });
  }

}
